<template>
  <v-data-table
    v-bind:class="[Store == 'utilizador_colheita' ? 'elevation-1 colheita-tabela' : 'elevation-1']"
    :headers="TableHeaders"
    :items="TableItems"
    multi-sort
    :search="search"
    :footer-props="{itemsPerPageText : 'Itens por página:', itemsPerPageOptions : [10,25,50], itemPerPageAllText: 'Todos'}"
    no-data-text="Não existem elementos para mostrar"
    no-results-text="Não foram encontrados resultados para a pesquisa"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title class="primaryText">{{TableTitle}}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>

        <AddDialog
          :DialogTitle="formTitle()"
          :FormFields="FormFields"
          :MyObject="MyObject"
          :MyIndex="MyIndex"
          :ModalNewText="ModalNewText"
          :Store="Store"
        />

        <DeleteDialog
          v-if="Store != 'utilizador_colheita'"
          :MyObject="MyObject"
          :MyIndex="MyIndex"
          :Store="Store"
          :ModalDeleteText="ModalDeleteText"
          :DeleteDialogTitle="DeleteDialogTitle"
        />

        <DeleteDialogColheita
          v-if="Store == 'utilizador_colheita'"
          :MyObject="MyObject"
          :MyIndex="MyIndex"
          :Store="Store"
          :ModalDeleteText="ModalDeleteText"
          :DeleteDialogTitle="DeleteDialogTitle"
        />

        <ColheitaDialog :MyObject="MyObject" :MyIndex="MyIndex" :Store="Store" />

        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :color="$primary"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.estado="{ item }">
      <v-menu bottom origin="center center" transition="scale-transition">
        <template v-slot:activator="{ on: menu }">
          <v-icon
            v-on="{ ...menu }"
            :color="GetStateColor(item.estado)"
          >{{GetStateIcon(item.estado)}}</v-icon>
        </template>
        <v-list>
          <v-list-item
            v-bind:class="[item.estado == state.estado && item.estado == 1 ? 'ativo' : (item.estado == state.estado && item.estado == 0 ? 'inativo' : (item.estado == state.estado && item.estado == -1 ? 'pendente' : (item.estado == state.estado && item.estado == 2 ? 'entregue' : '')))]"
            v-for="(state, index) in getStates"
            :key="index"
            @click="SetState(state, item)"
          >
            <v-list-item-title>{{ state.nome }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template v-slot:item.valor="{ item }">{{item.valor}} €</template>
    <template v-slot:item.action="{ item }">
      <v-icon
        medium
        class="mr-2"
        v-for="(action, idx) in TableActions"
        :key="idx"
        :color="action.color"
        @click="ActionExecute(action.action, item)"
      >{{action.icon}}</v-icon>
    </template>
    <template v-slot:no-data>
      <!-- NO DATA -->
    </template>
  </v-data-table>
</template>

<script>
import CRUD from "@/mixins/_CRUD"
import UC from "@/mixins/_UC"
export default {
  props: {
    TableItems: Array,
    TableHeaders: Array,
    FormFields: Array,
    TableActions: Array,
    TableTitle: String,
    ModalNewText: String,
    ModalUpdateText: String,
    Store: String,
    ModalDeleteText: String,
    DeleteDialogTitle: String
  },
  mixins: [CRUD, UC],
  components: {
    AddDialog: () => import("@/components/dialogs/AddDialog"),
    DeleteDialog: () => import("@/components/dialogs/DeleteDialog"),
    DeleteDialogColheita: () =>
      import("@/components/dialogs/DeleteDialogColheita"),
    ColheitaDialog: () => import("@/components/dialogs/ColheitaDialog")
  },
  data: () => ({
    search: "",
    MyIndex: -1,
    MyObject: {},
    MyDefaultObject: {},
    STATES: {
      utilizador: [
        {
          estado: 1,
          nome: "Ativo"
        },
        {
          estado: 0,
          nome: "Inativo"
        }
      ],
      utilizador_colheita: [
        {
          estado: 1,
          nome: "Sim"
        },
        {
          estado: 0,
          nome: "Não"
        }
      ],
      galardao_pedido: [
        {
          estado: -1,
          nome: "Pendente"
        },
        {
          estado: 1,
          nome: "Concedido"
        },
        {
          estado: 0,
          nome: "Recusado"
        },
        {
          estado: 2,
          nome: "Entregue"
        }
      ]
    }
  }),

  computed: {
    getStates() {
      return this.STATES[this.Store]
    },
    getSession() {
      return this.$store.getters["session/getState"]
    }
  },

  watch: {},

  created() {
    this.$eventBus.$on("ClearDialog", () => {
      this.ClearDialog()
    })

    this.$eventBus.$on("ExportarPdf", (type, data) => {
      this.ExportarPdf(type, data)
    })

    this.$eventBus.$on("RefreshCotas", item => {
      this.MyObject = item
      this.$forceUpdate()
    })
  },

  methods: {
    GetStateColor(state) {
      switch (state) {
        case -1:
          return "amber"
          break

        case 0:
          return "red lighten-1"
          break

        case 1:
          return "light-green darken-1"
          break

        case 2:
          return "cyan darken-1"
          break

        default:
          break
      }
    },

    GetStateIcon(state) {
      switch (state) {
        case -1:
          return "info"
          break

        case 0:
          return "cancel"
          break

        case 1:
          return "check_circle"
          break

        case 2:
          return "emoji_events"
          break

        default:
          break
      }
    },

    formTitle() {
      return this.MyIndex === -1 ? this.ModalNewText : this.ModalUpdateText
    },

    ActionExecute(action, item) {
      if (!action || !item) return

      switch (action) {
        case "edit": {
          this.MyIndex = this.TableItems.indexOf(item)
          this.MyObject = Object.assign({}, item)
          this.$eventBus.$emit("AddDialog", true)
          break
        }

        case "delete": {
          this.MyIndex = this.TableItems.indexOf(item)
          this.MyObject = Object.assign({}, item)
          this.$eventBus.$emit("DeleteDialog", true)
          break
        }

        case "colheita": {
          this.getSession.Colheita = Object.assign({}, item)
          this.$store.dispatch(
            "utilizador_colheita/get",
            this.getSession.Colheita.id_colheita
          )
          this.$eventBus.$emit("ColheitaDialog", true)
          break
        }

        case "delete_colheita": {
          if (!this.getSession.hasOwnProperty("Colheita")) return

          this.getSession.Colheita.uc = Object.assign({}, item)
          this.$eventBus.$emit("DeleteDialogColheita", true)
          break
        }

        case "comprovativo_donativo": {
          var file = this.$moment().unix()
          this.ExportarPdf("ComprovativoDonativo", {
            nome: item.nome,
            data: item.data,
            email: item.email,
            morada: item.morada,
            nif: item.nif,
            valor: item.valor,
            file: file
          })
          break
        }

        default:
          break
      }
    },

    ExportarPdf(type, data) {
      this.$store.dispatch("comprovativo/" + type, data).then(res => {
        if (res) {
          window.open(`${this.$files}/comprovativos/${data.file}.pdf`, "_blank")
          this.$toast.success(this.$success)
        } else this.$toast.error(this.$error)
      })
    },

    ClearDialog() {
      this.MyObject = Object.assign({}, this.MyDefaultObject)
      this.MyIndex = -1

      if (this.getSession.hasOwnProperty("Colheita"))
        delete this.getSession.Colheita

      this.$forceUpdate()
    },

    SetState(state, item) {
      if (this.Store == "utilizador_colheita") {
        item.estado = state.estado
        this.getSession.Colheita.uc = Object.assign({}, item)
        setTimeout(() => {
          this.SaveUtilizadorColheita(false)
        }, 50)
      } else {
        item.estado = state.estado

        this.MyIndex = this.TableItems.indexOf(item)
        this.MyObject = Object.assign({}, item)

        setTimeout(() => {
          this.save(false)
        }, 50)
      }
    }
  }
}
</script>

<style>
.v-menu__content {
  border-radius: 0px !important;
  box-shadow: 0 0 10px 0px #00000021 !important;
  -webkit-box-shadow: 0 0 10px 0px #00000021 !important;
}

.v-menu__content .v-list {
  padding: 0 !important;
}

.ativo,
.inativo,
.pendente,
.entregue,
.ativo .v-list-item__title,
.inativo .v-list-item__title,
.pendente .v-list-item__title,
.entregue .v-list-item__title {
  color: #fff !important;
  text-align: center !important;
}

.ativo {
  background-color: #7cb242 !important;
}

.inativo {
  background-color: #ef5350 !important;
}

.pendente {
  background-color: #ffc107 !important;
}

.entregue {
  background-color: #00acc1 !important;
}

.colheita-tabela {
  width: 80% !important;
  margin: 0 auto !important;
  margin-top: 5% !important;
}
</style>
